<template>

  <v-autocomplete v-model="model"
                  label="Region"
                  placeholder="Region"
                  :items="regionsArray"
                  item-text="name"
                  :clearable="true"
                  :loading="loading"
                  return-object="return-object"
                  :disabled="!federationID"></v-autocomplete>

</template>

<script>

import Vue from 'vue'

export default {
  name: 'RegionSelector',
  props: ['value', 'emptyOption', 'federationID'],
  data: () => ({
    regions: {},
    loading: null
  }),
  computed: {
    regionsArray () {
      return Object.values(this.regions)
    },

    model: {
      get () {
        return this.regions[this.value] || null
      },
      set (s) {
        this.$emit('input', s.id)
      }
    }
  },
  methods: {
    fetchRegions () {
      this.loading = true
      this.$store.dispatch('getFederationRegions', this.federationID)
        .then(regions => {
          this.regions = {}
          this.setRegion(regions)
          this.loading = false
        })
        .catch((err) => {
          console.error('Failed to get regions', err)
          this.loading = false
        })
    },

    setRegion (region) {
      Vue.set(this.regions, region.id, region)
      for (const sub of region.subregions) {
        this.setRegion(sub)
      }
    }
  },
  watch: {
    federationID () {
      this.fetchRegions()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/RegionSelector.vue